import { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Button from '../../components/Button';
import Notification from '../../components/Notification';
import { DASHBOARD_ROUTE } from '../../routes/types';
import { getAllNotifications } from '../../services/notifications';
import { useNavigate } from 'react-router-dom';
import { addOrRemoveDaysToGivenDate, DateFormats, formatDate } from '../../utils/utils';

const Actions = () => {
  const notificationData = getAllNotifications();
  const navigate = useNavigate();
  const timeSensitiveTasks = notificationData.slice(0, 3).map((notification) => {
    const newDate = addOrRemoveDaysToGivenDate(new Date(), 25);
    notification.date = formatDate(
      newDate,
      DateFormats.SHORT_MONTH_DAY_YEAR
    ) as string;

    return notification;
  });;
  const removed = timeSensitiveTasks.splice(1, 1);
  const otherNotifications = notificationData.slice(3, notificationData.length);
  const unreadNotificationsCount = notificationData.filter(
    (x) => !x.isRead
  ).length;

  const [timeSensitiveData, setIsReadTimeSensitive] =
    useState(timeSensitiveTasks);
  const [otherData, setIsReadOtherData] = useState(otherNotifications);
  const [unread, setUnreadAmount] = useState(unreadNotificationsCount);

  const handleIsReadTimeSensitive = (idx: number) => {
    if (!timeSensitiveData[idx].isRead) {
      const newNotificationObj = [...timeSensitiveData];
      newNotificationObj[idx].isRead = true;

      setIsReadTimeSensitive((prev) => (prev = newNotificationObj));
    }
  };

  const handleIsReadOther = (idx: number) => {
    if (!otherData[idx].isRead) {
      const newNotificationObj = [...otherData];
      newNotificationObj[idx].isRead = true;

      setIsReadOtherData((prev) => (prev = newNotificationObj));
    }
  };

  const handleMarkAllRead = () => {
    const newOtherData = [...otherData];
    const newTimeSensitiveData = [...timeSensitiveData];

    newOtherData.map((x) => (x.isRead = true)) &&
      newTimeSensitiveData.map((x) => (x.isRead = true));

    setIsReadOtherData((prev) => (prev = newOtherData));
    setIsReadTimeSensitive((prev) => (prev = newTimeSensitiveData));
  };

  useEffect(() => {
    setUnreadAmount(
      timeSensitiveData.filter((x) => !x.isRead).length +
        otherData.filter((x) => !x.isRead).length
    );
  }, [timeSensitiveData, otherData]);

  const noNotifications = (
    <>
      <Row className={'mt-13'}>
        <Col className={'text-center col-12'}>
          <img
            src={`${process.env.PUBLIC_URL}/${'no-notifications.png'}`}
            alt={'no-notifications'}
          />
        </Col>
        <Col className={'col-12 text-center'}>
          <h2 className={'text-sm-20-lg-24 fw-light'}>No notifications yet</h2>
        </Col>
        <Col className={'col-12 text-center mb-10'}>
          <span className={'text-fs-6 fw-light'}>
            Stay tuned! Notifications about your activity will show up here.
          </span>
        </Col>
        <Col className={'col-12 text-center mt-13'}>
          <Button
            variant="primary-outline"
            size="lg"
            onClick={() => navigate(DASHBOARD_ROUTE)}
            className="align-self-center"
          >
            View Dashboard
          </Button>
        </Col>
      </Row>
    </>
  );

  const notifications = (
    <>
      <Row className={'mt-11 mt-lg-13 align-items-center'}>
        <Col className={'col-8'}>
          <Row>
            <Col className={'col-12 col-lg-8'}>
              <h2 className={'text-sm-24-lg-32 fw-light'}>Actions</h2>
            </Col>

            <Col className={'col-12 d-none d-lg-block'}>
              <span className={'text-fs-6 fw-light'}>
                Required Actions <strong>{timeSensitiveTasks.length}</strong>
              </span>
            </Col>
          </Row>
        </Col>

        <Col className={'col-12 col-lg-4'}>
          <Row className={'align-items-center'}>
            <Col className={'col-6 d-block d-lg-none'}>
              <span className={'text-fs-6 fw-light'}>
                Required Actions <strong>{timeSensitiveTasks.length}</strong>
              </span>
            </Col>

            <Col className={'col-6 col-lg-12 text-end'}></Col>
          </Row>
        </Col>
      </Row>

      <Row className={'mb-2 mt-10 mt-lg-12'}>
        <Col>
          <span className={'fw-bold text-sub text-light-grey'}></span>
        </Col>
        {timeSensitiveData.map((notification, idx) => {
          return (
            <Col key={idx} className={'col-12 mt-4'}>
              <Notification
                onClick={() => handleIsReadTimeSensitive(idx)}
                notificationData={notification}
              />
            </Col>
          );
        })}
      </Row>
    </>
  );

  return (
    <Container className={'cnd-custom-container'}>
      {!notificationData
        ? noNotifications
        : !unread
        ? noNotifications
        : notifications}
    </Container>
  );
};

export default Actions;
